'use client'


import HatchProfilePage from '@/components/HatchProfile/HatchProfilePage'


export default function Home() {

	return <HatchProfilePage />
}
